import Question from '../interfaces/question';
import Survey from '../interfaces/survey';

interface Paginate {
  survey: Survey;
}

const INITIAL_SURVEY_PAGE = 1;

const paginate = ({ survey }: Paginate): Map<number, Question[]> => {
  const { questions } = survey;
  let page = INITIAL_SURVEY_PAGE;
  return questions.reduce((acc: Map<number, Question[]>, cur: Question) => {
    acc.set(page, [...(acc.get(page) || []), cur]);
    page += 1;
    return acc;
  }, new Map());
};

interface GetPage {
  paginatedSurvey: Map<number, Question[]>;
  page: number;
  defaultValue: Question[];
}

const getPage = ({ paginatedSurvey, page, defaultValue }: GetPage): Question[] => {
  if (paginatedSurvey.has(page)) return paginatedSurvey.get(page) || defaultValue;
  return defaultValue;
};

const getQuestionIds = ({ page }: { page: Question[] }): number[] =>
  page.map((question) => question.id);

export { paginate, getPage, getQuestionIds, INITIAL_SURVEY_PAGE };
